var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"uk-flex uk-flex-column uk-margin uk-container"},[_c('h1',[_vm._v(_vm._s(_vm.post.title))]),_c('div',{staticClass:"widget-content",domProps:{"innerHTML":_vm._s(_vm.post.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }